<template>
  <!-- 弹窗 -->
  <div v-show="show == true">
    <div class="dialog outter-dialog common-dialog fadeInUp animated ">
      <div class="warp">
        <div class="close" v-if="closeAble">
          <i
            @click="handleClose"
            
            class="icon-cross"
          ></i>
        </div>
        <div class="content"  :class="{'center':center}">
          <!-- <slot name="content"></slot> -->
          <div v-html="message"></div>
        </div>
      </div>
    </div>
    <div class="mask rule-mask "></div>
  </div>
</template>
<script>
import { imageMixin } from "@/mixins";
import Message from './index'
export default {
  name: "wsDialog",
  mixins: [imageMixin],
  data(){
    return{
      closeAble:false,
      show:false,
      message:'',
      center:false,
      cb:null
    }
  },
  methods: {
    handleClose() {
      if(typeof this.cb === "function"){
        this.cb(this.hide)
      }else{
        this.hide();
      }
      
    },
    delayHide(s){
      let timer = null
      timer = setTimeout(() => {
          this.hide();
          timer = null
          clearTimeout(timer)
      }, s);
    },
    // 点击遮罩关闭
    hide() {
      // Message.changeShow(false)
      this.show = false
    }
  }
};
</script>
<style lang="scss" scoped>
.warp {
  font-family: $font-family;
  max-height: 80%;
  position: relative;
  color: #fff;
  .close {
    .icon-cross {
      position: absolute;
      z-index: 2;
      top: 0;
        // background: url("../../../static/images/dialogClose.png");
      background-repeat: no-repeat;
      @include res-size(
        $left: -68px,
        $width: 65px,
        $height: 65px,
        $background-size: 65px
      );
    }
    .icon-cross-cus {
      @include res-size($left: -20px);
    }
  }
  .content {
    // background: url("../../../static/images/dialogBg.png");
    background-repeat: no-repeat;
    position: relative;
    background-size: 100% 100%;
    @include res-size(
      $padding:45px,
      $width: 895px,
      $font-size:30px,
      $min-height: 480px
    );
  }
    .center{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/wsMessage/index.vue